import type { Schema } from '@cli-types/core-engine/schema.js'
import type { DevModeIntegrationArtifact } from '@cli-types/next-adapter/generators.js'
import { normalizeEntitySchema } from '@core-engine/schema/schema-reader/normalize-entity-schema.js'
import { buildEntityDevModeLifecycleHooks } from './build-entity-dev-mode-lifecycle-hooks.js'
import { buildEntityDevModeSnippets } from './build-entity-dev-mode-snippets.js'
import { createDevModeIntegrationArtifact } from './create-dev-mode-integration-artifact.js'
export function buildEntityDevModeIntegration(
  schema: Schema,
  adminDir: string,
  actionImportPath: string,
  adminImportAlias?: string
): DevModeIntegrationArtifact {
  const normalizedSchema = normalizeEntitySchema(schema)

  return createDevModeIntegrationArtifact(
    normalizedSchema,
    'entity',
    adminDir,
    buildEntityDevModeSnippets(normalizedSchema, actionImportPath, adminImportAlias),
    buildEntityDevModeLifecycleHooks(normalizedSchema, adminImportAlias),
    adminImportAlias
  )
}
